import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { ProductsAssignedToRolesService } from 'src/app/shared/services/products-assigned-to-roles.service';

export interface productGroupEditData {
  editData: any;
}

@Component({
    selector: 'app-product-group-popup',
    templateUrl: './product-group-popup.component.html',
    styleUrls: ['./product-group-popup.component.scss'],
    standalone: false
})
export class ProductGroupPopupComponent implements OnInit {

 Formvalid: FormGroup;
  productGroupName:any;
  productGroupId=0;
  validation_messages;
  buttonName="save"
  constructor(
    private errormessages: ErrorMessages,
    public dialogref: MatDialogRef<ProductGroupPopupComponent>,
    private services:ProductsAssignedToRolesService,
    private spinner: NgxUiLoaderService,
    private snackbar: MatSnackBar,
     @Inject(MAT_DIALOG_DATA) public data:productGroupEditData,
      private validation: validationmethod

  ) { 
    this.validation_messages = this.errormessages.productGroupMapping;
  }

  ngOnInit(): void {

     this.Formvalid = new FormGroup({
          productGroupNameControler: new FormControl('', [Validators.required]),
        });

        if(this.data.editData){
          console.log(this.data.editData);
          this.buttonName="Update"
        this.productGroupId=this.data.editData.product_group_id;
        this.productGroupName=this.data.editData.product_group_name
          
        }
  }

  onCancel(){
    this.buttonName="Save"
    this.dialogref.close(null)
  }

  onSaveClick(){
     if (!this.Formvalid.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.Formvalid);

      this.validation.getvalidationmessage();

    } else {
    let object={
      productGroupId:this.productGroupId,
      productGroupName:this.productGroupName
    }
    this.spinner.start()
    this.services.insertProductGroup(object).subscribe(res=>{
      console.log(res);
      if(res.error){
        this.spinner.stop()
          this.snackbar.open(res.statusMessage, "OK", {
            duration: 5000,
          });
      }else{
          this.snackbar.open(res.statusMessage, "OK", {
            duration: 5000,
          });
          this.spinner.stop()
          this.buttonName="Save"
        this.dialogref.close(1)
      }
      
    })
  }
  }

}
